import { _t } from '../base'

export function initStep2() {
    if ($('.id--16').length) {
        moveAddStep2Elements()
        step2TextChanges()
        appendExpirationDatesToOrderSummary()
    }
}

function moveAddStep2Elements() {}

function step2TextChanges() {
    // $('.order-icon.order-delivery').text('test')
    $('#orderFormButton').text(_t('cart.step2.nextStepBtn'))
}

function appendExpirationDatesToOrderSummary() {
    // Get stored expiration data
    const storedData = JSON.parse(localStorage.getItem('productsExpirationData') || '[]')

    // Check each order summary item
    $('.order-summary-inner .order-summary-item[data-micro="cartItem"]').each(function () {
        const productElement = $(this)
        const productSku = productElement.attr('data-micro-sku')

        // Find matching product in stored data
        const storedProduct = storedData.find((item) => item.id === productSku)

        if (storedProduct && storedProduct.expirationDate) {
            const price = productElement.find('.cart-item-price')

            // Create expiration element
            const expirationElement = $(`
                <div class="cart-item-expiration">
                    ${storedProduct.expirationDate}
                </div>
            `)

            // Insert after product name
            expirationElement.prependTo(price)
        }
    })
}
